import { render } from "./zhannaxiaoxiguanli.vue?vue&type=template&id=a42e6b30&scoped=true"
import script from "./zhannaxiaoxiguanli.vue?vue&type=script&lang=js"
export * from "./zhannaxiaoxiguanli.vue?vue&type=script&lang=js"

import "./zhannaxiaoxiguanli.vue?vue&type=style&index=0&id=a42e6b30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42e6b30"]])

export default __exports__